export default __webpack_public_path__ + "static/media/trace_mission.16d4ef90.svg";